// @flow
import React from 'react';
import { resizeImage } from 'lib/common';
import cx from 'classnames';
import './PartnerCard.scss';

type Props = {
  id: string,
  title: string,
  thumbnail: string,
  oneColumn?: boolean,
  urlSlug: string,
  partnerUrl: string,
  body?: string,
};

const PartnerCard = ({ thumbnail, body, title, oneColumn }: Props) => {
  const imgUrl = resizeImage(thumbnail, 250, 250);
  const style = {
    backgroundImage: `url(${imgUrl})`,
  };
  
  return (
    <div className={cx('PartnerCard', { 'one-column': oneColumn, empty: !thumbnail })}>
      <div className="card-header">
        {thumbnail && (
          <div className="thumbnail-wrapper" style={style}>
            {body && (
              <div className="thumbnail-overlay">
                <div className="overlay-content">
                  <p className="overlay-description">{body}</p>
                </div>
              </div>
            )}
          </div>
        )}
        {!thumbnail && (
          <div className="thumbnail-placeholder">
            <span role="img" aria-label="파트너">
              🤝
            </span>
          </div>
        )}
      </div>
      
      <div className="card-content">
        <div className="content-header">
          <h3 className="partner-title">{title}</h3>
        </div>
        
        {body && !thumbnail && (
          <div className="partner-description">
            {body}
          </div>
        )}
      </div>
    </div>
  );
};

PartnerCard.defaultProps = {
  oneColumn: false,
};

export default PartnerCard;



// WEBPACK FOOTER //
// ./src/components/common/PartnerCard/PartnerCard.js